export default __webpack_public_path__ + "static/screen-1-800ab3add1ecbe3ca2b3e084a5a8abdb.png";